import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export function CustomerStep2Company({ formData, onChange }) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-2 sm:col-span-2">
          <Label className="text-slate-700 dark:text-slate-300">Company Name <span className="text-red-500">*</span></Label>
          <Input
            value={formData.company_name}
            onChange={(e) => onChange('company_name', e.target.value)}
            placeholder="Acme Pharmaceuticals Pvt Ltd"
            className="border-slate-300 dark:border-slate-600 dark:bg-slate-700"
            data-testid="company-name-input"
          />
        </div>
        <div className="space-y-2">
          <Label className="text-slate-700 dark:text-slate-300">Company Code <span className="text-red-500">*</span></Label>
          <Input
            value={formData.company_code}
            onChange={(e) => onChange('company_code', e.target.value.toUpperCase())}
            placeholder="ACMEPHARMA"
            className="border-slate-300 dark:border-slate-600 dark:bg-slate-700 font-mono uppercase"
            maxLength={10}
          />
          <p className="text-xs text-slate-500 dark:text-slate-400">Unique identifier (max 10 chars)</p>
        </div>
        <div className="space-y-2">
          <Label className="text-slate-700 dark:text-slate-300">Phone</Label>
          <Input
            value={formData.phone}
            onChange={(e) => onChange('phone', e.target.value)}
            placeholder="+91 98765 43210"
            className="border-slate-300 dark:border-slate-600 dark:bg-slate-700"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label className="text-slate-700 dark:text-slate-300">Address</Label>
        <Input
          value={formData.address}
          onChange={(e) => onChange('address', e.target.value)}
          placeholder="123 Industrial Area, Sector 5"
          className="border-slate-300 dark:border-slate-600 dark:bg-slate-700"
        />
      </div>

      <div className="grid grid-cols-3 gap-4">
        <div className="space-y-2">
          <Label className="text-slate-700 dark:text-slate-300">City</Label>
          <Input
            value={formData.city}
            onChange={(e) => onChange('city', e.target.value)}
            placeholder="Delhi"
            className="border-slate-300 dark:border-slate-600 dark:bg-slate-700"
          />
        </div>
        <div className="space-y-2">
          <Label className="text-slate-700 dark:text-slate-300">State</Label>
          <Input
            value={formData.state}
            onChange={(e) => onChange('state', e.target.value)}
            placeholder="Delhi NCR"
            className="border-slate-300 dark:border-slate-600 dark:bg-slate-700"
          />
        </div>
        <div className="space-y-2">
          <Label className="text-slate-700 dark:text-slate-300">Country</Label>
          <Input
            value={formData.country}
            onChange={(e) => onChange('country', e.target.value)}
            placeholder="India"
            className="border-slate-300 dark:border-slate-600 dark:bg-slate-700"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label className="text-slate-700 dark:text-slate-300">Website</Label>
        <Input
          value={formData.website}
          onChange={(e) => onChange('website', e.target.value)}
          placeholder="https://www.acmepharma.com"
          className="border-slate-300 dark:border-slate-600 dark:bg-slate-700"
        />
      </div>
    </div>
  );
}
